import { create } from "zustand";
import { _Componentes_WebApiCalls_Post } from "../../ComponentesGlobales/WebApiCalls";
import { useStoreHome } from "../Home/useStoreHome";
import moment from "moment";
import { MensajeError, MensajeInfo, MensajeToastExito } from "../../componentes/FuncionesLocales";
import { crearRequestMercaderiasPiSeun, evaluarFiltrosMercaderia } from "../../servicios/mercaderiasPiSeun";
import { listarClientes } from "../../servicios/clientes";
import { obtenerPcIdActual } from "../../servicios/configuracionPc";

let claveMercaderiasDespachos = null;
let secuenciaMercaderiasDespachos = 0;
let solicitudClientesDespachos = 0;

export const useStoreDespachos = create((set, get) => {
    return {

        Fecha: new Date(),
        Numero: "",
        Cliente: null,
        Unidades: 1,
        Kilos: 0,
        Mercaderia: null,
        TabSeleccionado: 0,
        FechasConDespachos: [],

        limpiar: () => {
            set({
                Fecha: new Date(),
                Unidades: 1,
                Kilos: 0,
                Mercaderia: null,
            });
        },

        limpiezaTotal: () => {
            set({
                Fecha: new Date(),
                Cliente: null,
                Unidades: 1,
                Kilos: 0,
                Mercaderia: null,
            });
        },


        ListaClientes: [],
        BuscandoClientes: false,
        ClientesBase: "",
        ErrorClientes: "",
        BuscandoProcesos: false,
        getClientes: async ({ forzar = false } = {}) => {
            const base = useStoreHome.getState().EmpresaId;
            if (!base) return [];
            const miSolicitud = ++solicitudClientesDespachos;
            set({
                BuscandoClientes: true,
                ErrorClientes: "",
                ...(get().ClientesBase !== base ? { ListaClientes: [], Cliente: null } : {}),
                ClientesBase: base,
            });
            try {
                const respuesta = await listarClientes({ EmpresaId: base, forzar });
                if (miSolicitud !== solicitudClientesDespachos || useStoreHome.getState().EmpresaId !== base) return [];
                if (respuesta.error) {
                    set({ ListaClientes: [], ErrorClientes: respuesta.error });
                    MensajeError(respuesta.error);
                    return [];
                }
                const lista = respuesta.data?.Lista || [];
                set({ ListaClientes: lista });
                return lista;
            } catch (error) {
                if (miSolicitud === solicitudClientesDespachos) {
                    set({ ListaClientes: [], ErrorClientes: error.message });
                }
                MensajeError(error.message);
                return [];
            } finally {
                if (miSolicitud === solicitudClientesDespachos && useStoreHome.getState().EmpresaId === base) {
                    set({ BuscandoClientes: false });
                }
            }
        },

        ListaMercaderias: [],
        Procesando: false,
        BuscandoMercaderia: false,
        limpiarResultadosMercaderias: () => {
            claveMercaderiasDespachos = null;
            secuenciaMercaderiasDespachos += 1;
            set({ ListaMercaderias: [], BuscandoMercaderia: false });
        },
        getMercaderia: async ({ codigo = "", descripcion = "", signal } = {}) => {
            const evaluacion = evaluarFiltrosMercaderia({ codigo, descripcion });
            if (!evaluacion.valido) { get().limpiarResultadosMercaderias(); return []; }
            if (claveMercaderiasDespachos === evaluacion.clave) return get().ListaMercaderias;
            const miSecuencia = ++secuenciaMercaderiasDespachos;
            claveMercaderiasDespachos = evaluacion.clave;
            const sParametros = crearRequestMercaderiasPiSeun(useStoreHome.getState().EmpresaId, 0, evaluacion.filtros);
            if (!sParametros.EmpresaId) return [];
            set({ BuscandoMercaderia: true });
            try {
                const data = await _Componentes_WebApiCalls_Post("Combos/MercaderiasPiSeun", sParametros, { signal });
                if (data.aborted) return [];
                if (data.error) {
                    if (miSecuencia === secuenciaMercaderiasDespachos) claveMercaderiasDespachos = null;
                    return { error: data.error };
                }
                const lista = data.data?.Lista || [];
                if (miSecuencia === secuenciaMercaderiasDespachos) set({ ListaMercaderias: lista });
                return lista;
            } catch (error) {
                if (miSecuencia === secuenciaMercaderiasDespachos) claveMercaderiasDespachos = null;
                return { error: error.message };
            } finally {
                if (miSecuencia === secuenciaMercaderiasDespachos) set({ BuscandoMercaderia: false });
            }
        },

        DespachoOk: false,
        insert: async () => {
            if (!useStoreHome.getState().EmpresaId) return;

            const st = get();
            const NroDespachoNum = Number(st.Numero) || 0;
            const OperadorIdNum = Number(localStorage.getItem("Id") || 0);
            const PcIdNum = obtenerPcIdActual();
            const Codbar = st.CodbarItem ? String(st.CodbarItem.sCodbar || "") : "";


            const KilosNum = Number(st.Kilos) || 0;
            const UnidadesNum = Number(st.Unidades) || 0;

            const mu = st.MercaderiaUnidad || {};
            const Unidad = Codbar
                ? {
                    Id: Number(mu.Id || st.CodbarItem?.UnidadId || 0),
                    sDescripcion: String(mu.sDescripcion || st.CodbarItem?.UnidadCombo || ""),
                    sCodigo: String(mu.sCodigo || st.CodbarItem?.UnidadCodigo || "P")
                }
                : null;

            const sParametros = {
                NroDespacho: NroDespachoNum,
                Fecha: moment(st.Fecha).format("YYYY-MM-DD"),
                Cliente: st.Cliente?.Id
                    ? { Id: Number(st.Cliente.Id), sDescripcion: st.Cliente.sDescripcion }
                    : { Id: 0, sDescripcion: String(st.Cliente || "") },
                Mercaderia: st.Mercaderia ? { Id: Number(st.Mercaderia.Id), sDescripcion: st.Mercaderia.sDescripcion } : new Object(),
                OperadorId: OperadorIdNum,
                PcId: PcIdNum,
                EmpresaId: useStoreHome.getState().EmpresaId,
                Kilos: KilosNum,
                Unidades: UnidadesNum,
                Codbar: Codbar
            };



            if (Unidad) sParametros.Unidad = Unidad;

            try {

                const data = await _Componentes_WebApiCalls_Post("Despachos/InsertPISeun", sParametros);
                if (!data) return MensajeError("Respuesta vacía del servidor.");
                if (data.error) return MensajeError(data.error);

                set({ DespachoOk: true, CodbarItem: null });
                get().limpiarResultadosMercaderias();
                get().getClientes();
                get().getDatosDespachos({ NroDespacho: NroDespachoNum });
                get().getFechas();
                MensajeToastExito("Se registró el despacho correctamente");
            } catch (error) {
                const fallbackMsg = (error?.response?.data && JSON.stringify(error.response.data)) || error.message || "Error desconocido";
                MensajeError(fallbackMsg);
            }


        },


        DespachoId: 0,
        ListaDetalle: [],
        BuscandoDetalle: false,
        getDatosDespachos: async (opts = {}) => {
            if (!useStoreHome.getState().EmpresaId || get().BuscandoDetalle) return;
            const Numero = opts.NroDespacho ?? get().Numero;
            const DespachoId = opts.DespachoId ?? get().DespachoId;
            if (!Numero && !DespachoId) return;
            const sParametros = {
                ...(Numero ? { NroDespacho: Numero } : {}),
                ...(DespachoId ? { DespachoId } : {}),
                EmpresaId: useStoreHome.getState().EmpresaId,
            };

            try {
                set({ BuscandoDetalle: true });
                const data = await _Componentes_WebApiCalls_Post("Despachos/GetPISeun", sParametros);

                if (data.error) {
                    MensajeError(data.error);
                } else {
                    set({
                        ListaDetalle: data.data.Lista,
                        Fecha: new Date(data.data.Fecha),
                        Cliente: data.data.Cliente,
                        DespachoId: data.data.DespachoId,
                    });
                }
            } catch (error) {
                MensajeError(error.message);
            } finally {
                set({ BuscandoDetalle: false });
            }
        },


        Seleccionados: [],
        Eliminando: false,
        EliminoOk: false,
        eliminarCodbar: async (items) => {
            if (!useStoreHome.getState().EmpresaId || get().Eliminando) return;
            if (!items || items.length === 0) {
                MensajeError("No hay códigos de barras proporcionados.");
                return;
            }
            set({ Eliminando: true });
            try {
                let eliminacionesExitosas = 0;
                let errores = [];

                // Procesar cada elemento de forma secuencial para evitar sobrecarga
                for (const element of items) {
                    const sParametros = {
                        DespachoId: element.Despacho_Id,
                        Codbar: element.sCodbar,
                        OperadorId: Number(localStorage.getItem("Id") || 0),
                        EmpresaId: useStoreHome.getState().EmpresaId,
                    };
                    try {
                        const data = await _Componentes_WebApiCalls_Post("Despachos/CodbarEliminarPiSeun", sParametros);
                        if (data?.error) {
                            errores.push(`Error al eliminar ${element.sCodBar}: ${data.error}`);
                        } else {
                            eliminacionesExitosas++;
                        }
                    } catch (error) {
                        errores.push(`Error al eliminar ${element.sCodBar}: ${error.message}`);
                    }
                }

                // Actualizar estado después de procesar todos los elementos
                if (eliminacionesExitosas > 0) {
                    set({ EliminoOk: true, Seleccionados: [] });
                    get().getDespachosPorFechaPantalla();
                }

                // Mostrar mensajes apropiados
                if (errores.length === 0) {
                    MensajeToastExito(`Se eliminaron ${eliminacionesExitosas} códigos de barras correctamente.`);
                } else if (eliminacionesExitosas > 0) {
                    MensajeInfo(`Se eliminaron ${eliminacionesExitosas} códigos. ${errores.length} errores ocurrieron.`);
                } else {
                    MensajeError("No se pudo eliminar ningún código de barras.");
                }

            } catch (error) {
                get().getDespachosPorFechaPantalla();
                MensajeError(error.message);
            } finally {
                set({ Eliminando: false });
            }
        },

        ListaGrillaPantalla: [],
        getDespachosPorFechaPantalla: async () => {
            if (!useStoreHome.getState().EmpresaId) return;
            const sParametros = {
                Fecha: moment(get().Fecha).format("YYYY-MM-DD"),
                FechaHasta: moment(get().Fecha).format("YYYY-MM-DD"),
                EmpresaId: useStoreHome.getState().EmpresaId,
            };
            try {
                const data = await _Componentes_WebApiCalls_Post("Despachos/GetPISeunPorFecha", sParametros);
                if (data.error) {
                    MensajeError(data.error);
                } else {
                    set({ ListaGrillaPantalla: data.data.Lista });
                }
            } catch (error) {
                MensajeError(error.message);
            }
        },



        ListaGrilla: [],
        getDespachosPorFecha: async (fechaOverride, fechaHastaOverride) => {
            if (!useStoreHome.getState().EmpresaId) return;
            const sParametros = {
                Fecha: moment(fechaOverride ? fechaOverride : get().Fecha).format("YYYY-MM-DD"),
                FechaHasta: moment(fechaHastaOverride ? fechaHastaOverride : get().FechaHasta ? get().FechaHasta : get().Fecha).format("YYYY-MM-DD"),
                EmpresaId: useStoreHome.getState().EmpresaId,
            };
            try {
                const data = await _Componentes_WebApiCalls_Post("Despachos/GetPISeunPorFecha", sParametros);
                if (data.error) {
                    MensajeError(data.error);
                } else {
                    set({ ListaGrilla: data.data.Lista });
                }
            } catch (error) {
                MensajeError(error.message);
            }
        },

        CodbarItem: null,
        BuscandoCodbarItem: false,
        getCodbar: async (Codbar) => {
            if (!useStoreHome.getState().EmpresaId || get().BuscandoCodbarItem) return;
            const sParametros = {
                EmpresaId: useStoreHome.getState().EmpresaId,
                Codbar
            };
            set({ BuscandoCodbarItem: true, CodbarItem: null });
            try {
                const data = await _Componentes_WebApiCalls_Post("Despachos/GetStock", sParametros);
                if (data.error) {
                    MensajeError(data.error);
                } else {
                    set({ CodbarItem: data.data });
                }
            } catch (error) {
                MensajeError(error.message);
            }
            set({ BuscandoCodbarItem: false })
        },

        MercaderiaUnidad: null,
        buscandoMercaderiaUnidad: false,
        getMercaderiaUnidad: async () => {
            if (!useStoreHome.getState().EmpresaId || get().buscandoMercaderiaUnidad || !get().Mercaderia || !get().Mercaderia.Id) { return; }
            const sParametros = { EmpresaId: useStoreHome.getState().EmpresaId, Id: get().Mercaderia.Id };
            set({ buscandoMercaderiaUnidad: true });
            try {
                const data = await _Componentes_WebApiCalls_Post("Mercaderias/GetUnidadPorMercaderia", sParametros);
                if (data.error) {
                    MensajeError(data.error);
                } else {
                    set({ MercaderiaUnidad: data.data });
                }
            }
            catch (error) {
                MensajeError(error.message);
            } finally {
                set({ buscandoMercaderiaUnidad: false });
            }
        },

        buscandoFechas: false,
        getFechas: async () => {
            if (!useStoreHome.getState().EmpresaId || get().buscandoFechas) { return; }
            const sParametros = { EmpresaId: useStoreHome.getState().EmpresaId };
            set({ buscandoFechas: true });
            try {
                const data = await _Componentes_WebApiCalls_Post("Despachos/DistintasFechas", sParametros);

                if (data.error) {
                } else {
                    var fechas = [];
                    for (const item of data.data.Lista) {
                        if (item.Fecha) {
                            fechas.push(new Date(item.Fecha))
                        }
                    }
                    set({ FechasConDespachos: fechas });
                }
            }
            catch (error) {
            } finally {

            }
            set({ buscandoFechas: false });
        },
    };
});
